import api from '@/api'
import moment from "moment"

export default {
  namespaced: true,
  state: {
    wallet: {
      project_reports: [], //load projects reports where created_invoice = 0
      support_payments: [], //load support_payments where created_invoice = 0
      invoices: []
    }
  },
  getters: {
    invoices: function(state) {
      return state.wallet.invoices.sort(function(a, b) {
        if (a.date_added < b.date_added) {
          return 1
        }
        if (a.date_added > b.date_added) {
          return -1
        }
        return 0
      }).map(i => {

        i.display_amount = (i.amount / 100).toFixed(2)
        i.date_added = moment(i.date_added).format('MMMM Do YYYY')

        i.projects.forEach(p => {
          p.report.display_amount_earned = (p.report.amount_earned / 100).toFixed(2)
          p.report.display_bonus =  (p.report.bonus / 100).toFixed(2)
        })

        i.support.forEach(s => {
          s.display_amount_earned = (s.amount_earned / 100).toFixed(2)
        })
        return i
      })
    },
    invoiceTotal: function(state) {
      let t = 0
      state.wallet.invoices.forEach(i => {
        t += i.amount
      })
      return (t / 100).toFixed(2)
    },
    projectAmount: function(state) {
      let total = 0;
      state.wallet.project_reports.forEach(p => {
        total += p.amount_earned + p.bonus;
      })
      return total > 0 ? (total / 100).toFixed(2) : total;
    },
    supportAmount: function(state) {
      let total = 0;
      state.wallet.support_payments.forEach(p => {
        total += p.amount_earned
      })
      return total > 0 ? (total / 100).toFixed(2) : total;
    },
    canRequestPayment: function(state) {
      let total = 0;
      state.wallet.project_reports.forEach(p => {
        total += p.amount_earned
      })
      state.wallet.support_payments.forEach(p => {
        total += p.amount_earned
      })

      if (total > 0) {
        return true
      }


      return false
    }
  },
  mutations: {
    loaded_wallet(state, data) {
      state.wallet = data;
    },
  },
  actions: {
    async load(context) {
      let response = await api({
        method: "GET",
        url: `/account/user/wallet`
      })
      context.commit('loaded_wallet', response)
    },
    async requestPayment(context) {
      await api({
        method: "GET",
        url: `/account/user/request-payment`
      })
      context.dispatch('load')
    }
  },
}
